module.exports = "https://cdn.hellotech.com/client-assets/Printer_a680e4b88bb5d095b60ef9d112a5e245.png";